angular
  .module("skeyenoteWebApp")
  .controller("UserManagementCtrl", UserManagementController);

function UserManagementController($scope, $http, baseUrlSrv, ngToast) {
  "ngInject";

  ngToast.dismiss();

  $scope.users = [];
  $scope.roles = [];
  $scope.showAddUser = false;
  $scope.searchText = "";
  $scope.newUser = {
    userName: "",
    password: "",
    email: "",
    selectedRoles: [],
    roleInput: "",
  };
  $scope.newRoleName = "";

  var PASSWORD_PATTERN =
    /^(?=(.*[A-Z]){2})(?=(.*[a-z]){2})(?=(.*\d){2})(?=(.*[^A-Za-z0-9]){2}).{10,}$/;

  const adminApiBase = () => baseUrlSrv.getRestApiBase() + "/admin";

  function showToast(message, type) {
    const verticalPosition = "bottom";
    const timeout = "3000";
    if (type === "success") {
      ngToast.success({ content: message, verticalPosition, timeout });
    } else {
      ngToast.danger({ content: message, verticalPosition, timeout });
    }
  }

  function handleError(defaultMessage) {
    return function (data, status) {
      if (status === 401 || status === 403) {
        showToast("You do not have permission on this page", "danger");
        setTimeout(function () {
          window.location = baseUrlSrv.getBase();
        }, 3000);
        return;
      }
      showToast((data && data.message) || defaultMessage, "danger");
    };
  }

  /* ── chip input helpers ── */

  function addRoleToArray(arr, roleName) {
    const trimmed = roleName.trim();
    if (trimmed && arr.indexOf(trimmed) === -1) {
      arr.push(trimmed);
      return true;
    }
    return false;
  }

  function focusEl(evt) {
    const input = evt.currentTarget.querySelector(".chip-input-field");
    if (input) input.focus();
  }

  function handleRoleKeydown(arr, inputModel, $event) {
    if ($event.key === "Enter" || $event.key === ",") {
      $event.preventDefault();
      if (inputModel.roleInput && inputModel.roleInput.trim()) {
        addRoleToArray(arr, inputModel.roleInput);
        inputModel.roleInput = "";
      }
    }
    if ($event.key === "Backspace" && !inputModel.roleInput && arr.length > 0) {
      arr.pop();
    }
  }

  function getAvailable(arr) {
    return $scope.roles.filter(function (r) {
      return arr.indexOf(r) === -1;
    });
  }

  /* ── new user form chip input ── */

  $scope.focusRoleInput = function ($event) {
    focusEl($event);
  };

  $scope.addNewUserRole = function (role, $event) {
    $event.stopPropagation();
    addRoleToArray($scope.newUser.selectedRoles, role);
  };

  $scope.removeNewUserRole = function (index, $event) {
    $event.stopPropagation();
    $scope.newUser.selectedRoles.splice(index, 1);
  };

  $scope.onNewUserRoleKeydown = function ($event) {
    handleRoleKeydown($scope.newUser.selectedRoles, $scope.newUser, $event);
  };

  $scope.getAvailableRoles = function () {
    return getAvailable($scope.newUser.selectedRoles);
  };

  /* ── inline edit role chip input ── */

  $scope.focusUserRoleInput = function (user, $event) {
    focusEl($event);
  };

  $scope.addUserEditRole = function (user, role, $event) {
    $event.stopPropagation();
    addRoleToArray(user.selectedEditRoles, role);
  };

  $scope.removeUserEditRole = function (user, index, $event) {
    $event.stopPropagation();
    user.selectedEditRoles.splice(index, 1);
  };

  $scope.onUserEditRoleKeydown = function (user, $event) {
    handleRoleKeydown(user.selectedEditRoles, user, $event);
  };

  $scope.getAvailableEditRoles = function (user) {
    return getAvailable(user.selectedEditRoles);
  };

  /* ── API operations ── */

  $scope.loadUsers = function () {
    $http
      .get(adminApiBase() + "/users")
      .success(function (data) {
        $scope.users = (data.body || []).map(function (user) {
          return {
            username: user.username,
            email: user.email || "",
            enabled: user.enabled,
            roles: user.roles || [],
            editingRoles: false,
            selectedEditRoles: [],
            roleInput: "",
            editingEmail: false,
            resettingPassword: false,
            newPassword: "",
          };
        });
      })
      .error(handleError("Failed to load users"));
  };

  $scope.loadRoles = function () {
    $http
      .get(adminApiBase() + "/roles")
      .success(function (data) {
        $scope.roles = data.body || [];
      })
      .error(handleError("Failed to load roles"));
  };

  $scope.toggleAddUser = function () {
    $scope.showAddUser = !$scope.showAddUser;
    $scope.newUser = {
      userName: "",
      password: "",
      email: "",
      selectedRoles: [],
      roleInput: "",
    };
  };

  $scope.createUser = function () {
    if (!$scope.newUser.userName.trim() || !$scope.newUser.password.trim()) {
      showToast("Username and password can not be empty.", "danger");
      return;
    }
    if (!PASSWORD_PATTERN.test($scope.newUser.password)) {
      showToast(
        "Password must be at least 10 characters with 2 uppercase, 2 lowercase, 2 digits, and 2 symbols.",
        "danger",
      );
      return;
    }
    $http
      .post(adminApiBase() + "/users", {
        userName: $scope.newUser.userName.trim(),
        password: $scope.newUser.password,
        email: $scope.newUser.email.trim(),
        roles: $scope.newUser.selectedRoles,
      })
      .success(function () {
        showToast("User created.", "success");
        $scope.showAddUser = false;
        $scope.loadUsers();
        $scope.loadRoles();
      })
      .error(handleError("Failed to create user"));
  };

  $scope.deleteUser = function (user) {
    BootstrapDialog.confirm({
      closable: false,
      closeByBackdrop: false,
      closeByKeyboard: false,
      title: "",
      message: "Delete user '" + user.username + "'? This can not be undone.",
      callback: function (result) {
        if (result) {
          $http
            .delete(
              adminApiBase() + "/users/" + encodeURIComponent(user.username),
            )
            .success(function () {
              showToast("User deleted.", "success");
              $scope.users = $scope.users.filter(function (u) {
                return u.username !== user.username;
              });
            })
            .error(handleError("Failed to delete user"));
        }
      },
    });
  };

  $scope.toggleEnabled = function (user) {
    var nextEnabled = !user.enabled;
    $http
      .put(
        adminApiBase() +
          "/users/" +
          encodeURIComponent(user.username) +
          "/enabled/" +
          nextEnabled,
      )
      .success(function () {
        user.enabled = nextEnabled;
        showToast(
          "User " + (nextEnabled ? "enabled." : "disabled."),
          "success",
        );
      })
      .error(handleError("Failed to update user"));
  };

  $scope.editEmail = function (user) {
    user.editingEmail = true;
  };

  $scope.cancelEditEmail = function (user) {
    user.editingEmail = false;
    $scope.loadUsers();
  };

  $scope.saveEmail = function (user) {
    $http
      .put(
        adminApiBase() +
          "/users/" +
          encodeURIComponent(user.username) +
          "/email",
        {
          email: user.email,
        },
      )
      .success(function () {
        user.editingEmail = false;
        showToast("Email updated.", "success");
      })
      .error(handleError("Failed to update email"));
  };

  $scope.editRoles = function (user) {
    user.editingRoles = true;
    user.selectedEditRoles = angular.copy(user.roles);
    user.roleInput = "";
  };

  $scope.cancelEditRoles = function (user) {
    user.editingRoles = false;
    user.selectedEditRoles = [];
    user.roleInput = "";
  };

  $scope.saveRoles = function (user) {
    var desiredRoles = user.selectedEditRoles;
    var toAdd = desiredRoles.filter(function (role) {
      return user.roles.indexOf(role) === -1;
    });
    var toRemove = user.roles.filter(function (role) {
      return desiredRoles.indexOf(role) === -1;
    });
    var calls = [];
    toAdd.forEach(function (role) {
      calls.push(
        $http.post(
          adminApiBase() +
            "/users/" +
            encodeURIComponent(user.username) +
            "/roles/" +
            encodeURIComponent(role),
        ),
      );
    });
    toRemove.forEach(function (role) {
      calls.push(
        $http.delete(
          adminApiBase() +
            "/users/" +
            encodeURIComponent(user.username) +
            "/roles/" +
            encodeURIComponent(role),
        ),
      );
    });

    if (calls.length === 0) {
      user.editingRoles = false;
      return;
    }

    var pending = calls.length;
    var failed = false;
    calls.forEach(function (call) {
      call.then(
        function () {
          pending--;
          if (pending === 0 && !failed) {
            user.roles = angular.copy(desiredRoles);
            user.editingRoles = false;
            showToast("Roles updated.", "success");
            $scope.loadRoles();
          }
        },
        function (response) {
          failed = true;
          showToast(
            (response.data && response.data.message) ||
              "Failed to update roles",
            "danger",
          );
        },
      );
    });
  };

  $scope.togglePasswordReset = function (user) {
    user.resettingPassword = !user.resettingPassword;
    user.newPassword = "";
  };

  $scope.resetPassword = function (user) {
    if (!user.newPassword || !user.newPassword.trim()) {
      showToast("New password can not be empty.", "danger");
      return;
    }
    if (!PASSWORD_PATTERN.test(user.newPassword)) {
      showToast(
        "Password must be at least 10 characters with 2 uppercase, 2 lowercase, 2 digits, and 2 symbols.",
        "danger",
      );
      return;
    }
    $http
      .put(
        adminApiBase() +
          "/users/" +
          encodeURIComponent(user.username) +
          "/password",
        {
          password: user.newPassword,
        },
      )
      .success(function () {
        showToast("Password reset for '" + user.username + "'.", "success");
        user.resettingPassword = false;
        user.newPassword = "";
      })
      .error(handleError("Failed to reset password"));
  };

  $scope.addRole = function () {
    var roleName = $scope.newRoleName.trim();
    if (!roleName) {
      showToast("Role name can not be empty.", "danger");
      return;
    }
    $http
      .post(adminApiBase() + "/roles/" + encodeURIComponent(roleName))
      .success(function () {
        showToast("Role created.", "success");
        $scope.newRoleName = "";
        $scope.loadRoles();
      })
      .error(handleError("Failed to create role"));
  };

  $scope.deleteRole = function (roleName) {
    BootstrapDialog.confirm({
      closable: false,
      closeByBackdrop: false,
      closeByKeyboard: false,
      title: "",
      message:
        "Delete role '" +
        roleName +
        "'? It will be removed from every user that has it.",
      callback: function (result) {
        if (result) {
          $http
            .delete(adminApiBase() + "/roles/" + encodeURIComponent(roleName))
            .success(function () {
              showToast("Role deleted.", "success");
              $scope.loadRoles();
              $scope.loadUsers();
            })
            .error(handleError("Failed to delete role"));
        }
      },
    });
  };

  var init = function () {
    $scope.loadUsers();
    $scope.loadRoles();
  };

  init();
}
